interface ArrowsDownSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ArrowsDownSVG = ({ color, style }: ArrowsDownSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="63"
    height="52"
    viewBox="0 0 63 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1284_1281)">
      <path
        d="M37.6173 29.5641V40.2911H43.7161L31.5287 51.2204L19.3438 40.2911H25.4426V29.5641"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3435 16.0368V24.8126H25.3938L13.2089 35.7419L1.02148 24.8126H7.12032V14.4775"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.6574 15.9672V24.7431L37.5586 24.8127L49.7461 35.7419L61.9335 24.8127H55.8347V14.4101"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9014 0.779602C40.788 4.47959 37.5586 9.91158 37.5586 15.9673V20.9736"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.6572 15.9672C43.6572 7.58117 51.8928 0.783813 62.0533 0.783813"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0967 0.779602C22.2101 4.47959 25.4395 9.91158 25.4395 15.9673V20.9736"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.343 15.9672C19.343 7.58117 11.1048 0.783813 0.944336 0.783813"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1284_1281">
        <rect width="63" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowsDownSVG;
